module.exports = __webpack_public_path__ + "media/images/workplace/social-ico/microsoft-ico-5d839675b97df9331806e8d33c2cc4cb.svg";